import { render, staticRenderFns } from "./TimePolicyCom.vue?vue&type=template&id=04109889&"
import script from "./TimePolicyCom.vue?vue&type=script&lang=js&"
export * from "./TimePolicyCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports